import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import { Space } from 'antd';
import { BaseQuestionReportComponent } from '../../../bases';
import { SpeakingEmptySubmissionArea, SpeakingSettingsBadgesComponent, SpeakingSubmissionArea } from '../common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledSpaceContainer = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
export var SpeakingReportComponent = function SpeakingReportComponent(_ref) {
  var _speakingAnswer$value;

  var states = _ref.states,
      actions = _ref.actions;
  var speakingAnswer = states.speakingAnswer;
  var speakingSettings = states.speakingSettings;
  var speakingLabel = states.speakingLabel;
  var audioFile = speakingAnswer === null || speakingAnswer === void 0 ? void 0 : (_speakingAnswer$value = speakingAnswer.value) === null || _speakingAnswer$value === void 0 ? void 0 : _speakingAnswer$value.audioFile;
  var hasSubmission = Boolean(audioFile && (audioFile.url || audioFile.id));
  return /*#__PURE__*/_jsx(BaseQuestionReportComponent, {
    states: states,
    actions: actions,
    children: /*#__PURE__*/_jsxs(StyledSpaceContainer, {
      direction: "vertical",
      size: "middle",
      children: [/*#__PURE__*/_jsx(SpeakingSettingsBadgesComponent, {
        settings: speakingSettings,
        label: speakingLabel,
        currentAttempts: speakingAnswer === null || speakingAnswer === void 0 ? void 0 : speakingAnswer.attemptCount
      }), hasSubmission ? /*#__PURE__*/_jsx(SpeakingSubmissionArea, {
        answer: speakingAnswer,
        label: speakingLabel,
        variant: "review"
      }) : /*#__PURE__*/_jsx(SpeakingEmptySubmissionArea, {
        label: speakingLabel
      })]
    })
  });
};